import rootParams from './rootParams';

const getThreatActorsCountsByDateApi = async (params) => {
  const myHeaders = new Headers();
  const token = localStorage.getItem('token');
  myHeaders.append('Authorization', `bearer ${token}`);

  if (params.clientSelected) {
    myHeaders.append('ClientId', params.clientSelected);
  }

  const requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow',
  };

  const baseUrl = `${rootParams.rootUrl}threat-actors/threat-actor-counts-by-date`;
  let url;

  if (params) {
    const queryParams = {};

    if (params.startDate) {
      queryParams.start_date = params.startDate;
    }

    if (params.endDate) {
      queryParams.end_date = params.endDate;
    }

    if (params.assetType) {
      queryParams.asset_type = params.assetType;
    }

    if (params.riskLevel) {
      queryParams.risk_level = params.riskLevel;
    }

    if (params.type) {
      queryParams.threat_actor_type = params.type;
    }

    if (params.page) {
      queryParams.page = params.page;
    }

    url = `${baseUrl}?${new URLSearchParams(queryParams)}`;
  } else {
    url = baseUrl;
  }

  const response = await fetch(url, requestOptions);

  if (!response.ok) {
    throw new Error('Get threat actors failed');
  }

  return response.json();
};

export default getThreatActorsCountsByDateApi;
